import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  addItemToCart,
  removeItemFromCart,
} from "../../redux/reducers/cart.reducer";
import { useHistory } from "react-router-dom";
import { setSelectedProduct } from "../../redux/reducers/compare.reducer";
import { makeStyles } from "@mui/styles/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faPlusCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { isMobile } from "react-device-detect";
import { Button } from "@mui/material";
const useStyles = makeStyles({
  cartCard: {
    // borderWidth: 1,
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    width: "200px",
    justifyContent: "center",
    alignItems: "center",
  },
  productItemCounterView: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  counterValue: {
    paddingBottom: 4,
    paddingTop: 4,
    fontSize: 18,
    fontWeight: "500",
    textAlign: "center",
  },
  centerElement: { justifyContent: "center", alignItems: "center" },
  toggleCounterButton: {
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: isMobile ? 15 : 20,
  },
  info: {
    display: "flex",
    flexDirection: "column",
  },
  fabContainer: {
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: -25,
    right: 5,
  },
  fab: {
    width: 45,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  actualPriceText: {
    color: "green",
    fontWeight: "bold",
    fontSize: isMobile ? 10 : 13,
  },
  discountedPriceText: {
    color: "red",
    fontWeight: "bold",
    textAlign: "bottom",
    marginTop: 3,
    marginLeft: 8,
    textDecorationLine: "line-through",
    fontSize: isMobile ? 8 : 11,
  },
});

const CartProduct = ({ index, productItem, language }) => {
  const { t } = useTranslation();
  const [cartLoading, setCartLoading] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();
  const history = useHistory();
  const styles = useStyles();
  const priceAfterDiscount =
    !!productItem.discount &&
    Number(productItem.discount) > 0 &&
    !!productItem.priceAfterDiscount
      ? productItem.priceAfterDiscount
      : undefined;
  const handleQuantityChange = (product) => {
    setCartLoading(true);
    dispatch(addItemToCart(product));
    setCartLoading(false);
  };
  const handleRemove = () => {
    setCartLoading(true);
    dispatch(removeItemFromCart(productItem));
    setCartLoading(false);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        marginTop: isMobile && index == 0 ? 90 : 0,
      }}
    >
      <div
        className={styles.cartCard}
        style={{ borderColor: theme.dark.primary }}
      >
        {productItem.images && productItem.images.length && (
          <img
            src={productItem.images[0]}
            style={{
              width: isMobile ? 80 : 120,
              height: isMobile ? 80 : 120,
              resizeMode: "contain",
            }}
          />
        )}
        <div
          onClick={() => {
            history.push("/product/" + productItem.id);
          }}
          className={styles.info}
          style={{
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: isMobile ? 10 : 0,
            paddingRight: isMobile ? 10 : 0,
          }}
        >
          <Typography
            style={{
              textAlign: "center",
              color: "black",
              fontSize: isMobile ? 10 : 14,
              maxWidth: 180,
            }}
          >
            {language == "ar" ? productItem.titleAr : productItem.titleEn}
          </Typography>
          <Typography
            style={{
              textAlign: "center",
              maxWidth: 150,
              fontSize: isMobile ? 10 : 14,
            }}
          >{`${productItem.brand ?? ""} `}</Typography>
          <Typography
            style={{
              textAlign: "center",
              maxWidth: 150,
              fontSize: isMobile ? 10 : 14,
            }}
          >{`${
            productItem.categoryInfo[language == "ar" ? "titleAr" : "titleEn"]
          }`}</Typography>
          <Typography
            style={{
              maxWidth: 150,
              textAlign: "center",
              fontSize: 13,
              marginTop: 5,
              marginBottom: 5,
              fontWeight: "400",
              color: "gray",
            }}
          >
            {`${productItem.sizeOrCapacity ?? ""} ${
              productItem.measureUnit ?? ""
            } `}
          </Typography>
          {productItem.price && (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                {priceAfterDiscount && priceAfterDiscount > 0 && (
                  <Typography className={styles.actualPriceText}>
                    {`${Number(
                      priceAfterDiscount * productItem.cartQuantity
                    ).toFixed(2)} ${t("product.currency")}`}
                  </Typography>
                )}
                {/* <Typography className={styles.discountedPriceText}>
                  {`${Number(
                    productItem.price * productItem.cartQuantity
                  ).toFixed(2)} ${t("product.currency")}`}
                </Typography> */}
              </div>
            </div>
          )}
        </div>
        <div className={styles.info}>
          <div className={styles.productItemCounterView} style={{ bottom: 6 }}>
            <div
              style={{ cursor: "pointer" }}
              //disabled={productItem.cartQuantity === 1 || cartLoading}
              onClick={() => {
                if (productItem.cartQuantity > 1) {
                  handleQuantityChange({
                    ...productItem,
                    cartQuantity: -1,
                    cartTotal:
                      !!productItem.discount &&
                      Number(productItem.discount) > 0 &&
                      !!productItem.priceAfterDiscount
                        ? -productItem.priceAfterDiscount
                        : -productItem.productItem.price,
                  });
                }
              }}
            >
              <FontAwesomeIcon
                className={styles.toggleCounterButton}
                icon={faMinusCircle}
              />
            </div>
            <Typography className={styles.counterValue}>
              {productItem.cartQuantity}
            </Typography>
            <div
              style={{ cursor: "pointer" }}
              // disabled={cartLoading}
              onClick={() => {
                handleQuantityChange({
                  ...productItem,
                  cartQuantity: 1,
                });
              }}
            >
              <FontAwesomeIcon
                className={styles.toggleCounterButton}
                icon={faPlusCircle}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              top: 14,
            }}
          >
            <Button
              style={{
                textTransform: 'capitalize'
              }}
              size={'small'}
              onClick={() => handleRemove()}
              color="error"
              variant="contained"
            >
              {t("general.remove")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartProduct;
